import wsbLogoWhite from "../../resources/WSB_logo_white.png";
import wsbLogoBlack from "../../resources/WSB_logo_black.png";
import { useCustomBrandingAssetStore } from "./useCustomBrandingAsset";

export const useGetBrandLogo = (deviceType: "desktop" | "mobileTable") => {
    const brandLogoPath = useCustomBrandingAssetStore(
        (store) => store.brandLogoPath
    );
    if (brandLogoPath) {
        return brandLogoPath;
    }

    // Non-custom branding
    return deviceType === "desktop" ? wsbLogoWhite : wsbLogoBlack;
};
